import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { AbstractUserService, IPerson, IUser } from "src/app/interfaces";
import { LogClass, Logger } from "src/app/logger";

@Component({
    selector: "circ-forward-by-owner",
    templateUrl: "./forwardByOwner.component.html",
    styleUrls: ["./forwardByOwner.component.scss"],
    standalone: false
})
@LogClass({ source: "ForwardByOwnerComponent" })
export class ForwardByOwnerComponent {
  public form = new UntypedFormGroup({
    responsible: new UntypedFormControl("", [Validators.required]),
    currentResponsible: new UntypedFormControl("", [Validators.required]),
    comment: new UntypedFormControl("", [])
  });

  @Input() people: IPerson[] = [];
  @Input() title: string;
  @Output() saveClick = new EventEmitter<IOverrideStepData>();
  @Output() abortClick = new EventEmitter<Event>();

  logger: Logger;

  constructor(private userService: AbstractUserService) {}

  public abort($event: Event): void {
    this.abortClick.emit($event);
  }
  public save(): void {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }

    this.userService
      .getUsers([
        this.form.value.responsible.login,
        this.form.value.currentResponsible.login
      ])
      .pipe(first(), this.logger.observableOperator("Override User"))
      .subscribe(([next, curr]) => {
        this.saveClick.emit({
          forwardTo: next,
          comment: this.form.value.comment,
          currentResponsible: curr
        });
      });
  }
}

interface IOverrideStepData {
  forwardTo: IUser;
  currentResponsible: IUser;
  comment: string;
}
